// extracted by mini-css-extract-plugin
module.exports = {"submit":"AuthenticationForm_submit__K_6_4"};